/// <reference types="./advisoryLockRelease.d.ts" />
/* eslint-disable @typescript-eslint/no-unused-expressions */
import { notOk, ok } from '@dossierhq/core';
import { buildSqliteSqlQuery } from '@dossierhq/database-adapter';
import { queryNoneOrOne } from '../QueryFunctions.js';
export async function advisoryLockRelease(database, context, name, handle) {
    const query = buildSqliteSqlQuery(({ sql }) => {
        sql `DELETE FROM advisory_locks WHERE name = ${name} AND handle = ${handle} RETURNING id`;
    });
    const deleteResult = await queryNoneOrOne(database, context, query);
    if (deleteResult.isError())
        return deleteResult;
    if (deleteResult.value !== null) {
        return ok(undefined);
    }
    const existingResult = await queryNoneOrOne(database, context, buildSqliteSqlQuery(({ sql }) => {
        sql `SELECT id FROM advisory_locks WHERE name = ${name}`;
    }));
    if (existingResult.isError())
        return existingResult;
    return notOk.NotFound(existingResult.value
        ? `Invalid handle used for releasing lock '${name}'`
        : `Failed releasing lock, no advisory lock with the name '${name}' exists`);
}
//# sourceMappingURL=advisoryLockRelease.js.map